import React, { Component } from "react";
import { Button, Form, Select } from "semantic-ui-react";
import { HomepageContext } from "context/homepageProvider";
import StackedBarChart from "components/charts/stackedBarChart";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import "scss/screens/homepage/topClaimAndChannel.scss";

export default class TopClaimAndChannel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dates: null,
      model: null,
    };
  }

  createSearchTopClaim = () => {
    const devicesOptions = [
      { key: "all", text: "ทั้งหมด", value: "all" },
      { key: "colper-5000k", text: "COLPER-5000K", value: "colper-5000k" },
      { key: "acr-100plus", text: "ACR-100PLUS", value: "acr-100plus" },
    ];

    return (
      <>
        <div className="search">
          <Form>
            <Form.Group inline>
              <Form.Field
                control={Select}
                options={devicesOptions}
                placeholder="ทั้งหมด"
                search
                value={this.state.model}
                onChange={(e, { value }) => this.setState({ model: value })}
              />

              <SemanticDatepicker
                onChange={(e, data) =>
                  this.setState({
                    dates: data.value,
                  })
                }
                placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                type="range"
              />
              <Button color="blue" onClick={() => this.setDataForSearch()}>
                ค้นหา
              </Button>
            </Form.Group>
          </Form>
        </div>
      </>
    );
  };

  setDataForSearch = () => {
    const { dates, model } = this.state;
    if (dates != null && dates.length > 1) {
      const data = {
        model: model,
        min_date: dates[0].toLocaleString().substring(0, 8),
        max_date: dates[1].toLocaleString().substring(0, 8),
      };
      this.context.getTopClaim(data);
    } else if (dates == null) {
      const data = {
        model: model,
        min_date: dates,
        max_date: dates,
      };
      this.context.getTopClaim(data);
    }
  };

  render() {
    return (
      <div className="topClaimAndChannel">
        {this.createSearchTopClaim()}

        <StackedBarChart />
      </div>
    );
  }
}

TopClaimAndChannel.contextType = HomepageContext;
